import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "../lib/business";
import TrustBadges from "./TrustBadges";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden bg-primary text-white grain"
    >
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1581783898377-1c85bf937427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxoYW5keW1hbiUyMHRvb2xzJTIwcmVwYWlyfGVufDB8fHx8MTc3ODkwOTM4Mnww&ixlib=rb-4.1.0&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 hero-overlay" />
      <div className="container-x relative py-20 sm:py-28 lg:py-32">
        <div className="max-w-3xl fade-in-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-3 py-1.5 text-xs font-bold tracking-widest uppercase text-accent">
            Local Handyman & Home Services
          </span>
          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-balance">
            Handyman Services in <span className="text-accent">Montgomery County</span> & the DMV
          </h1>
          <p className="mt-4 text-lg sm:text-xl font-semibold text-white/95">
            Quality Work. <span className="text-accent">Fair Pricing.</span> Clean Results.
          </p>
          <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl leading-relaxed">
            Professional handyman services for TV mounting, furniture assembly, fitness equipment
            assembly, appliance installation, curtain installation, picture and mirror hanging,
            playground assembly, moving help, basic repairs, and home maintenance across Montgomery
            County and the DMV.
          </p>
          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <Link to="/contact" data-testid="hero-request-estimate-btn" className="btn-gold">
              Request a Free Estimate <ArrowRight size={18} />
            </Link>
            <a href={BUSINESS.phoneHref} data-testid="hero-call-now-btn" className="btn-outline-light">
              <Phone size={18} /> Call or Text: {BUSINESS.phone}
            </a>
          </div>
          <TrustBadges variant="dark" />
        </div>
      </div>
    </section>
  );
}
